import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MailStateService } from '../services/mail-state.service';

@Injectable()
export class MailLoginGuard implements CanActivate {

  constructor(
    private mailStateService: MailStateService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (
      this.mailStateService.condition
    ) {
      return true;
    }

    this.router.navigate(['']);
    return false;
  }
}
